import { baseApi } from './baseApi'

export interface V1ArchiveOrder {
  orderId: number
  supplierId: number | null
  patientId: number | null
  patientName: string | null
  physicianName: string | null
  physicianFax: string | null
  status: string | null
  created: string | null
  completed: string | null
}

export interface V1ArchiveReport {
  reportId: number
  orderId: number
  supplierId: number | null
  patientName: string | null
  physicianName: string | null
  resultCode: number | null
  resultQualification: string | null
  testingStarted: string | null
  created: string | null
}

export interface V1ArchivePhysician {
  physicianId: number
  supplierId: number | null
  npi: string | null
  name: string | null
  fax: string | null
  phone: string | null
  email: string | null
  address: string | null
  city: string | null
  state: string | null
  zipCode: string | null
}

export interface V1ArchiveSearchOrdersParams {
  orderId?: string
  patientName?: string
  limit?: number
  offset?: number
}

export interface V1ArchiveSearchReportsParams {
  reportId?: string
  orderId?: string
  limit?: number
  offset?: number
}

export interface V1ArchiveSearchPhysiciansParams {
  q?: string
  npi?: string
  limit?: number
  offset?: number
}

export interface V1ArchiveSearchResult<T> {
  items: T[]
  total: number
}

export const v1ArchiveApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchV1Orders: builder.query<V1ArchiveSearchResult<V1ArchiveOrder>, V1ArchiveSearchOrdersParams>({
      query: (params) => ({
        url: '/lab/v1-archive/orders',
        params: params as Record<string, string | number | undefined>,
      }),
    }),
    searchV1Reports: builder.query<V1ArchiveSearchResult<V1ArchiveReport>, V1ArchiveSearchReportsParams>({
      query: (params) => ({
        url: '/lab/v1-archive/reports',
        params: params as Record<string, string | number | undefined>,
      }),
    }),
    searchV1Physicians: builder.query<V1ArchiveSearchResult<V1ArchivePhysician>, V1ArchiveSearchPhysiciansParams>({
      query: (params) => ({
        url: '/lab/v1-archive/physicians',
        params: params as Record<string, string | number | undefined>,
      }),
    }),
    getV1ReportDownloadUrl: builder.query<{ url: string }, number>({
      query: (reportId) => ({
        url: `/lab/v1-archive/reports/${reportId}/download-url`,
      }),
    }),
  }),
})

export const {
  useSearchV1OrdersQuery,
  useSearchV1ReportsQuery,
  useSearchV1PhysiciansQuery,
  useLazyGetV1ReportDownloadUrlQuery,
} = v1ArchiveApi
